/* ============================================================================
   mt-auto-gift.js  —  Regalo automático nativo (reemplaza la app Fokkio)
   ----------------------------------------------------------------------------
   Regla replicada de Fokkio "Regalo Gratis":
     - Si el subtotal (sin contar el regalo) >= $40.000 CLP  → agrega 1 regalo.
     - Si baja de $40.000  → quita el regalo.
     - El regalo es el producto "Regalo Gratis Sorpresa" (precio $0, SKU MT1019RGS).
     - Máximo 1 unidad por pedido. Si la clienta lo borra y sigue calificando,
       se vuelve a agregar (equivale a "Skip = OFF" en Fokkio).
   ----------------------------------------------------------------------------
   MODO PRUEBA: mientras LIVE = false, solo se activa para quien abra la web con
   ?mtgift=on (queda guardado en ese navegador). Así las clientas siguen con
   Fokkio y no hay regalo doble. Para salir a producción: poner LIVE = true,
   subir el archivo y desactivar Fokkio al mismo tiempo.
   ============================================================================ */
(function () {
  'use strict';

  var CONFIG = {
    giftVariantId: 42138581041227,   // "Regalo Gratis Sorpresa"
    thresholdPesos: 40000,           // umbral en CLP
    giftProperty: '_regalo',         // marca de línea del regalo
    LIVE: true,                      // ⬅️ ACTIVO para todas las clientas
    DEBUG: false
  };

  var THRESHOLD_CENTS = CONFIG.thresholdPesos * 100; // Shopify guarda CLP * 100

  // No correr en el editor de temas
  if (window.Shopify && window.Shopify.designMode) return;

  // ---- Gate de modo prueba -------------------------------------------------
  function isEnabled() {
    if (CONFIG.LIVE) return true;
    try {
      var u = new URL(window.location.href);
      var q = u.searchParams.get('mtgift');
      if (q === 'on') localStorage.setItem('mt_gift', 'on');
      if (q === 'off') localStorage.removeItem('mt_gift');
      return localStorage.getItem('mt_gift') === 'on';
    } catch (e) { return false; }
  }
  if (!isEnabled()) return;

  window.__mtGift = window.__mtGift || { loaded: false, mode: null, ver: 3, logs: [] };
  function log() {
    var msg = [].slice.call(arguments).join(' ');
    try { window.__mtGift.logs.push(msg); if (window.__mtGift.logs.length > 60) window.__mtGift.logs.shift(); } catch (e) {}
    if (CONFIG.DEBUG && window.console) console.log('[mt-gift]', msg);
  }
  window.__mtGift.loaded = true;
  window.__mtGift.mode = CONFIG.LIVE ? 'LIVE' : 'PRUEBA';

  // ---- Recuadro de diagnóstico (solo en DEBUG / modo prueba) ----------------
  function renderBadge() {
    if (!CONFIG.DEBUG || !document.body) return;
    var el = document.getElementById('mt-gift-badge');
    if (!el) {
      el = document.createElement('div');
      el.id = 'mt-gift-badge';
      el.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483647;max-width:92vw;background:rgba(0,0,0,.88);color:#38ff9b;font:11px/1.35 ui-monospace,Menlo,monospace;padding:8px 10px;border-radius:8px;white-space:pre-wrap;pointer-events:none;box-shadow:0 2px 10px rgba(0,0,0,.4)';
      document.body.appendChild(el);
    }
    var m = window.__mtGift || {};
    el.textContent = 'mt-gift [' + (m.mode || '?') + '] v' + (m.ver || '?') + '\n' + (m.logs || []).slice(-5).join('\n');
  }

  var origFetch = window.fetch.bind(window);

  // ---- Detección robusta de cambios en el carrito --------------------------
  // No envolvemos window.fetch (otras apps también lo envuelven y ganan, dejando
  // la nuestra sin efecto). En su lugar observamos el contador y el cajón del
  // carrito: el tema los vuelve a renderizar ante CUALQUIER cambio de carrito,
  // sin importar quién lo provocó. Un sondeo lento (solo con pestaña visible)
  // actúa de respaldo por si algún flujo no re-renderiza el contador.
  function attachObservers() {
    ['#cart-counter', '#CartDrawer-Body', 'cart-drawer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && !el.__mtObserved) {
        el.__mtObserved = true;
        try {
          new MutationObserver(function () { scheduleReconcile(); })
            .observe(el, { childList: true, subtree: true, characterData: true });
        } catch (e) {}
      }
    });
  }

  var pollStarted = false;
  function startPoll() {
    if (pollStarted) return;
    pollStarted = true;
    setInterval(function () {
      if (document.visibilityState === 'visible') scheduleReconcile();
    }, 6000);
  }

  // ---- Qué secciones refrescar según la página -----------------------------
  function getTargets() {
    var targets = [];
    if (document.querySelector('#cart-counter')) {
      targets.push({ section: 'cart-counter', target: '#cart-counter', htmlSel: '#shopify-section-cart-counter' });
    }
    if (document.querySelector('#CartDrawer-Body')) {
      targets.push({ section: 'cart-drawer', target: '#CartDrawer-Body', htmlSel: '#shopify-section-cart-drawer #CartDrawer-Body' });
    }
    var mc = document.getElementById('main-cart-items');
    if (mc && mc.dataset.id) {
      var id = mc.dataset.id;
      targets.push({ section: id, target: '#shopify-section-' + id + ' cart-items', htmlSel: '#shopify-section-' + id + ' cart-items' });
    }
    return targets;
  }

  function applySections(respSections, targets) {
    if (!respSections) return;
    targets.forEach(function (t) {
      var html = respSections[t.section];
      if (!html) return;
      var el = document.querySelector(t.target);
      if (!el) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(t.htmlSel);
        if (parsed) el.innerHTML = parsed.innerHTML;
      } catch (e) { log('applySections error', e); }
    });
  }

  function afterMutation(respSections, targets) {
    applySections(respSections, targets);
    try { if (typeof updateFreeShipping === 'function') updateFreeShipping(); } catch (e) {}
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mt-auto-gift' });
      }
    } catch (e) {}
  }

  // ---- Mutaciones (marcadas con X-MT-Gift para no auto-dispararse) ----------
  function mtPost(url, payload) {
    return origFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-MT-Gift': '1' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  function addGift(targets) {
    var props = {};
    props[CONFIG.giftProperty] = 'true';
    return mtPost(window.routes.cart_add_url, {
      items: [{ id: CONFIG.giftVariantId, quantity: 1, properties: props }],
      sections: targets.map(function (t) { return t.section; }),
      sections_url: window.location.pathname
    });
  }
  // Ajusta líneas de regalo por su "key" (preciso aunque haya varias líneas)
  function updateGiftLines(updates, targets) {
    return mtPost(window.routes.cart_update_url, {
      updates: updates,
      sections: targets.map(function (t) { return t.section; }),
      sections_url: window.location.pathname
    });
  }

  // ---- Núcleo: leer carrito y conciliar ------------------------------------
  var busy = false, rerun = false;

  function scheduleReconcile() {
    clearTimeout(scheduleReconcile._t);
    scheduleReconcile._t = setTimeout(reconcile, 300);
  }

  function reconcile() {
    if (busy) { rerun = true; return; }
    busy = true;
    origFetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (body) {
        // Shopify sirve /cart.js como JSON válido pero con content-type
        // "text/javascript"; por eso NO filtramos por content-type: parseamos
        // el cuerpo y solo omitimos si de verdad no es JSON (página de desafío).
        var cart = null;
        if (body) { try { cart = JSON.parse(body); } catch (e) { cart = null; } }
        if (!cart || !cart.items) { log('carrito no disponible (se omite)'); return null; }
        var giftLines = [], nonGiftCount = 0, giftCents = 0;
        (cart.items || []).forEach(function (it) {
          if (it.id === CONFIG.giftVariantId) { giftLines.push(it); giftCents += (it.final_line_price || 0); }
          else { nonGiftCount += it.quantity; }
        });
        var thresholdValue = (cart.total_price || 0) - giftCents;
        var qualifies = nonGiftCount > 0 && thresholdValue >= THRESHOLD_CENTS;
        var targets = getTargets();

        log('total', cart.total_price, 'sinRegalo', thresholdValue, 'califica', qualifies, 'lineasRegalo', giftLines.length);

        if (qualifies) {
          if (giftLines.length === 0) {
            log('accion: AGREGAR regalo');
            return addGift(targets).then(function (res) { afterMutation(res && res.sections, targets); });
          }
          // Debe quedar exactamente 1 línea de regalo con cantidad 1
          if (giftLines.length > 1 || giftLines[0].quantity !== 1) {
            log('accion: NORMALIZAR a 1 linea/1 unidad');
            var updates = {};
            giftLines.forEach(function (l, i) { updates[l.key] = (i === 0 ? 1 : 0); });
            return updateGiftLines(updates, targets).then(function (res) { afterMutation(res && res.sections, targets); });
          }
          log('accion: sin cambios (regalo ya correcto)');
        } else if (giftLines.length > 0) {
          log('accion: QUITAR regalo(s)');
          var upd = {};
          giftLines.forEach(function (l) { upd[l.key] = 0; });
          return updateGiftLines(upd, targets).then(function (res) { afterMutation(res && res.sections, targets); });
        }
        return null;
      })
      .catch(function (e) { log('reconcile error', e); })
      .finally(function () {
        busy = false;
        attachObservers();
        if (rerun) { rerun = false; scheduleReconcile(); }
      });
  }

  // ---- Arranque ------------------------------------------------------------
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.source === 'mt-auto-gift') return;
        scheduleReconcile();
      });
    }
  } catch (e) {}

  function init() {
    attachObservers();
    startPoll();
    if (CONFIG.DEBUG) { renderBadge(); setInterval(renderBadge, 1000); }
    reconcile();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  log('activo (modo ' + (CONFIG.LIVE ? 'LIVE' : 'PRUEBA') + ')');
})();
